export enum AppointmentReminderType {
  Scheduled = 'Scheduled',
  Reminder1 = 'Reminder 1',
  Reminder2 = 'Reminder 2',
  Reminder3 = 'Reminder 3',
  Reminder4 = 'Reminder 4',
}
